/**
 * This file was generated
 * Do not edit directly
 * See 'fusion-design-system/build-style-dictionary.js' for more info
 */

export const sizeUtilityVariants = (
    sizeUtilityKey:
        | "width"
        | "min-width"
        | "max-width"
        | "height"
        | "min-height"
        | "max-height"
        | "flex-basis"
) => ({
    "unset": `sui-u-${sizeUtilityKey}-unset`,
    "auto": `sui-u-${sizeUtilityKey}-auto`,
    // prettier-ignore
    "0": `sui-u-${sizeUtilityKey}-0`,
    "1/4": `sui-u-${sizeUtilityKey}-1-4`,
    "1/3": `sui-u-${sizeUtilityKey}-1-3`,
    "1/2": `sui-u-${sizeUtilityKey}-1-2`,
    "2/3": `sui-u-${sizeUtilityKey}-2-3`,
    "3/4": `sui-u-${sizeUtilityKey}-3-4`,
    "full": `sui-u-${sizeUtilityKey}-full`,
    "100vw": `sui-u-${sizeUtilityKey}-100vw`,
    "100vh": `sui-u-${sizeUtilityKey}-100vh`,
    "min-content": `sui-u-${sizeUtilityKey}-min-content`,
    "max-content": `sui-u-${sizeUtilityKey}-max-content`,
    "fit-content": `sui-u-${sizeUtilityKey}-fit-content`,
    "0-25x": `sui-u-${sizeUtilityKey}-0-25x`,
    "0-5x": `sui-u-${sizeUtilityKey}-0-5x`,
    "0-75x": `sui-u-${sizeUtilityKey}-0-75x`,
    "1x": `sui-u-${sizeUtilityKey}-1x`,
    "1-25x": `sui-u-${sizeUtilityKey}-1-25x`,
    "1-5x": `sui-u-${sizeUtilityKey}-1-5x`,
    "2x": `sui-u-${sizeUtilityKey}-2x`,
    "2-5x": `sui-u-${sizeUtilityKey}-2-5x`,
    "3x": `sui-u-${sizeUtilityKey}-3x`,
    "4x": `sui-u-${sizeUtilityKey}-4x`,
    "5x": `sui-u-${sizeUtilityKey}-5x`,
    "6x": `sui-u-${sizeUtilityKey}-6x`,
    "7x": `sui-u-${sizeUtilityKey}-7x`,
    "8x": `sui-u-${sizeUtilityKey}-8x`,
    "9x": `sui-u-${sizeUtilityKey}-9x`,
    "10x": `sui-u-${sizeUtilityKey}-10x`,
    "11x": `sui-u-${sizeUtilityKey}-11x`,
    "12x": `sui-u-${sizeUtilityKey}-12x`,
    "15x": `sui-u-${sizeUtilityKey}-15x`,
    "20x": `sui-u-${sizeUtilityKey}-20x`,
    "25x": `sui-u-${sizeUtilityKey}-25x`,
    "30x": `sui-u-${sizeUtilityKey}-30x`,
    "35x": `sui-u-${sizeUtilityKey}-35x`,
    "40x": `sui-u-${sizeUtilityKey}-40x`,
    "45x": `sui-u-${sizeUtilityKey}-45x`,
    "50x": `sui-u-${sizeUtilityKey}-50x`,
    "55x": `sui-u-${sizeUtilityKey}-55x`,
    "60x": `sui-u-${sizeUtilityKey}-60x`,
    "65x": `sui-u-${sizeUtilityKey}-65x`,
    "70x": `sui-u-${sizeUtilityKey}-70x`,
    "75x": `sui-u-${sizeUtilityKey}-75x`,
    "80x": `sui-u-${sizeUtilityKey}-80x`,
    "90x": `sui-u-${sizeUtilityKey}-90x`,
    "100x": `sui-u-${sizeUtilityKey}-100x`,
    "110x": `sui-u-${sizeUtilityKey}-110x`,
    "120x": `sui-u-${sizeUtilityKey}-120x`,
    "200x": `sui-u-${sizeUtilityKey}-200x`,
});
